var React = require('react');

function CloseRoundThick (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#clip0_1841_9747)"},[React.createElement("path",{"d":"M9.99997 18.7893C14.8542 18.7893 18.7892 14.8542 18.7892 10C18.7892 5.14582 14.8542 1.21072 9.99997 1.21072C5.14579 1.21072 1.21069 5.14582 1.21069 10C1.21069 14.8542 5.14579 18.7893 9.99997 18.7893Z","fill":"white","stroke":"#2D2927","strokeWidth":"1.59601","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M13.0598 6.84913L6.82538 13.0835","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.82538 6.84913L13.0598 13.0835","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

CloseRoundThick.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseRoundThick;

CloseRoundThick.default = CloseRoundThick;
